export default __webpack_public_path__ + "static/media/kaws3.b350be3d.jpg";